import React, { useState } from "react";
import { Phone } from "lucide-react";
import Call from "@/model/interface/Call";
import { Button } from "@/components/ui/button";
import VConExportButton from "@/components/vcon/VConExportButton";
import { useCallDialog } from "@/context/CallDialogContext";
import { isUnansweredCall } from "@/util/call";
import CallActionsMenu from "./CallActionsMenu";
import CallExpandedPanel from "./CallExpandedPanel";

interface CallDetailProps {
  call: Call;
  onRemoved?: () => void;
}

const CallDetail: React.FC<CallDetailProps> = ({ call, onRemoved }) => {
  const { setPendingDialNumber, openCallDialog } = useCallDialog();
  const [focusNotesRequest, setFocusNotesRequest] = useState(0);

  const dial = () => {
    setPendingDialNumber(call.phoneNumber);
    openCallDialog();
  };

  return (
    <div className="space-y-3 border-t border-border px-4 py-3" onClick={(event) => event.stopPropagation()}>
      <CallExpandedPanel call={call} focusNotesRequest={focusNotesRequest} />
      <div className="flex flex-wrap items-center gap-1">
        {isUnansweredCall(call.status) ? (
          <Button size="sm" onClick={dial}>
            <Phone className="h-3.5 w-3.5 mr-1" />
            Call back
          </Button>
        ) : (
          <Button variant="outline" size="sm" onClick={dial}>
            <Phone className="h-3.5 w-3.5 mr-1" />
            Call
          </Button>
        )}
        {call.id && <VConExportButton resource={{ type: "call", id: call.id }} iconOnly />}
        <CallActionsMenu call={call} onEditNotes={() => setFocusNotesRequest((value) => value + 1)} onRemoved={onRemoved} />
      </div>
    </div>
  );
};

export default CallDetail;
